import type {BackgroundProps} from "@/styles/background.types";
import theme from "@/styles/theme"
import {css} from "styled-components";

const colors = {
    "primary": theme.background.primary,
    "secondary": theme.background.secondary,
    "muted": theme.background.muted,
    "default": theme.background.default,
    "public": theme.background.default,
};

export const background = ({backgroundColor}: BackgroundProps) => {
    return backgroundColor && css`background-color: ${colors[backgroundColor]};`;
};
